import { RequestContext } from "../request-context";

export interface DiscoverReqCtx {
    requestContext: RequestContext
}

export interface WeightedFeature {
    feature: string,
    weight: number
}

export interface WatchlistQuery {
    tag: string,
    titleID: string,
    token: string
}

export interface Endpoint {
    partialURL: string,
    query: WatchlistQuery
}

export interface ScoutWatchlistAction {
    ajaxEnabled: boolean,
    endpoint: Endpoint,
    tag: string,
    text: string
}

export interface ScoutTitle {
    scoutSimilarity: number,
    scoutTitleDesc: string,
    scoutTitleEntityType: string,
    scoutTitleId: string,
    scoutTitleName: string,
    scoutTitleImage: string,
    scoutTitleRating?: number,
    scoutTitleRatingCount?: number,
    scoutTitleImdbScore?: number,
    scoutTitleImdbCount?: number,
    scoutWatchlistAction?: ScoutWatchlistAction,
    totalTime?: number,
    commonWeightedFeatures: WeightedFeature[],
    displayPrimeSash: boolean,
    scoutTitleMaturityRating?: string,
    scoutTitleCatalogAsin: string,
    playbackIdentifier?: string,
    resumeTime?: number,
    videoMaterialType?: string
}

export namespace GetScout {
    export interface ServersideRequest extends DiscoverReqCtx {
        ScoutTitleInputList: string[],
        ScoutCategoryList: string[],
        ScoutEntityType?: string
    };
    export interface ClientsideRequest extends DiscoverReqCtx {
        titleInputList: string
    };
    export interface Response {
        ScoutTitleOutputList: ScoutTitle[],
        ScoutTitleRequestedList: ScoutTitle[]
    };
};
